// extracted by mini-css-extract-plugin
export default {"wrap":"CountriesListBody-module__[local]___5riLD","title":"CountriesListBody-module__[local]___qYCr4","foot":"CountriesListBody-module__[local]___xmsH0"};